<span class="association-status-chip"
  [ngClass]="{'requested': status === 'requested', 'rejected': status === 'rejected', 'accepted': status === 'accepted'}">
  {{ status }}
</span>
